import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/external_link.svg'


const _withScopeId = n => (_pushScopeId("data-v-64510b29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "athlete-table" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { style: {"border-bottom":"1px solid #dddddd"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Style", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Entry", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Time", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  colspan: "5",
  style: {"font-size":"12px"}
}
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"padding-left":"5px"},
  src: _imports_0,
  width: "12",
  height: "12"
}, null, -1))
const _hoisted_29 = { style: {"float":"right"} }
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"padding-left":"5px"},
  src: _imports_0,
  width: "12",
  height: "12"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_athlete_favorite = _resolveComponent("athlete-favorite")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.athletess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.athletess, (athlete) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: athlete.id
          }, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    colspan: "5",
                    id: athlete.id
                  }, [
                    _createVNode(_component_athlete_favorite, {
                      athleteid: athlete.id
                    }, null, 8, ["athleteid"])
                  ], 8, _hoisted_3)
                ]),
                _createElementVNode("tr", _hoisted_4, [
                  _hoisted_5,
                  (athlete.results.length == 0)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Due"))
                    : (_openBlock(), _createElementBlock("th", _hoisted_7, "Place")),
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(athlete.results, (result, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: result.eventid
                  }, [
                    _createElementVNode("tr", {
                      class: _normalizeClass({
                'active-row ':
                  _ctx.$route.params.eventid == result.eventid &&
                  _ctx.$route.params.athleteid == athlete.id,
              })
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'Results',
                    params: {
                      meetid: _ctx.meetid,
                      clubid: _ctx.get_club_id_from_athlete_id(athlete.id),
                      eventid: result.eventid,
                      athleteid: athlete.id,
                    },
                  }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.get_style_short_from_event_id(result.eventid)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (result.place == -1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (result.status)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.get_dsq_code_from_status(result.status)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (result.place == 0)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.get_image_src_from_event_status(3),
                                width: "25",
                                height: "12"
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(result.place) + ". ", 1)
                              ], 64)),
                        _hoisted_12
                      ]),
                      _createElementVNode("td", null, _toDisplayString(result.entrytime), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'Result',
                    params: {
                      meetid: _ctx.meetid,
                      clubid: _ctx.get_club_id_from_athlete_id(athlete.id),
                      eventid: result.eventid,
                      athleteid: athlete.id,
                    },
                  }
                        }, {
                          default: _withCtx(() => [
                            (result.swimtime)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(result.swimtime), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (result.performance && result.performance > 1.08)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: {
                      name: 'Result',
                      params: {
                        meetid: _ctx.meetid,
                        clubid: _ctx.get_club_id_from_athlete_id(athlete.id),
                        eventid: result.eventid,
                        athleteid: athlete.id,
                      },
                    }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 🚀")
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (result.performance && result.performance > 1)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: {
                      name: 'Result',
                      params: {
                        clubid: _ctx.get_club_id_from_athlete_id(athlete.id),
                        eventid: result.eventid,
                        athleteid: athlete.id,
                      },
                    }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 🚀")
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                to: {
                      name: 'Result',
                      params: {
                        meetid: _ctx.meetid,
                        clubid: _ctx.get_club_id_from_athlete_id(athlete.id),
                        eventid: result.eventid,
                        athleteid: athlete.id,
                      },
                    }
                              }, null, 8, ["to"]))
                      ])
                    ], 2),
                    _createElementVNode("tr", {
                      class: _normalizeClass({
                'active-row':
                  _ctx.$route.params.eventid == result.eventid &&
                  _ctx.$route.params.athleteid == athlete.id,
                subline:
                  index == athlete.results.length - 1 && athlete.entries.length > 0,
              }),
                      style: {"line-height":"20px","font-size":"12px","color":"darkgrey"}
                    }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.get_round_name_from_event_id(result.eventid)), 1),
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16
                    ], 2)
                  ], 64))
                }), 128)),
                (athlete.entries.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(athlete.entries, (entry) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: entry.eventid
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass({
                  'active-row ':
                    _ctx.$route.params.eventid == entry.eventid &&
                    _ctx.$route.params.athleteid == athlete.id,
                })
                        }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              to: {
                      name: 'Heats',
                      params: {
                        meetid: _ctx.meetid,
                        clubid: _ctx.get_club_id_from_athlete_id(athlete.id),
                        eventid: entry.eventid,
                        athleteid: athlete.id,
                      },
                    }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.get_style_short_from_event_id(entry.eventid)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          (entry.entrystatus)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(entry.entrystatus), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_18, [
                                (_ctx.get_event_status_from_event_id(entry.eventid) == 3)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: 
                        _ctx.get_image_src_from_event_status(
                          _ctx.get_event_status_from_event_id(entry.eventid)
                        )
                      ,
                                      width: "25",
                                      height: "12"
                                    }, null, 8, _hoisted_19))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.get_weekday_from_event_id(entry.eventid)) + ". " + _toDisplayString(_ctx.get_time_from_event_id(entry.eventid)), 1)
                                    ], 64))
                              ])),
                          _createElementVNode("td", null, _toDisplayString(entry.entrytime), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              to: {
                      name: 'Result',
                      params: {
                        meetid: _ctx.meetid,
                        clubid: _ctx.get_club_id_from_athlete_id(athlete.id),
                        eventid: entry.eventid,
                        athleteid: athlete.id,
                      },
                    }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" ---- ")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _hoisted_20
                        ], 2),
                        _createElementVNode("tr", {
                          class: _normalizeClass({
                  'active-row':
                    _ctx.$route.params.eventid == entry.eventid &&
                    _ctx.$route.params.athleteid == athlete.id,
                }),
                          style: {"line-height":"20px","font-size":"12px","color":"darkgrey"}
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.get_round_name_from_event_id(entry.eventid)), 1),
                          _hoisted_21,
                          _hoisted_22,
                          _hoisted_23,
                          _hoisted_24
                        ], 2)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true),
                (_ctx.get_swrid_from_athlete_id(athlete.id))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            href: 
                    'https://www.swimstats.net/single?athlete1=' +
                    _ctx.get_full_name_from_athlete_id(athlete.id) +
                    ', ID:' +
                    _ctx.get_swrid_from_athlete_id(athlete.id)
                  
                          }, [
                            _createTextVNode("swimstats.net"),
                            _hoisted_28
                          ], 8, _hoisted_27)
                        ]),
                        _createElementVNode("span", _hoisted_29, [
                          _createElementVNode("a", {
                            href: 
                    'https://www.swimrankings.net/index.php?page=athleteDetail&athleteId=' +
                    _ctx.get_swrid_from_athlete_id(athlete.id)
                  
                          }, [
                            _createTextVNode("swimrankings.net"),
                            _hoisted_31
                          ], 8, _hoisted_30)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_32,
            _hoisted_33
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}